"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyEffect_OnAttackEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let ApplyEffect_OnAttackEventHandlerScript = class ApplyEffect_OnAttackEventHandlerScript {
    run(sequence, container, handler, event) {
        const { applyTo, onHitOnly = true, onCritOnly = false, effectsSelector = "allOf" } = handler.args.scriptArgs;
        if (onHitOnly && !event.args.hit) {
            return;
        }
        else if (onCritOnly && !event.args.crit) {
            return;
        }
        const targets = applyTo === "attacked" ? [event.args.targetId]
            : container.selectLivingTargets(event.subject, applyTo);
        let effects = handler.args.scriptArgs.effects;
        switch (effectsSelector) {
            case "allOf":
                effects = handler.args.scriptArgs.effects;
                break;
            case "oneOf":
                effects = [(0, Random_1.randomElement)(handler.args.scriptArgs.effects)].filter(Boolean);
                break;
        }
        const selectedEffects = handler.args.scriptArgs.effects
            .filter(({ percentChance = 100 }) => (0, Random_1.randomPercent)() <= percentChance);
        targets.forEach(targetId => {
            container.applyBuffs({
                sequence,
                creatorId: event.subject,
                targetId,
                effects: selectedEffects.filter(effect => !effect.effect.harmful)
            });
            container.applyDebuffs({
                sequence,
                attackerId: event.subject,
                targetId,
                effects: selectedEffects.filter(effect => effect.effect.harmful)
            });
        });
    }
};
ApplyEffect_OnAttackEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("ApplyEffect_OnAttack")
], ApplyEffect_OnAttackEventHandlerScript);
exports.ApplyEffect_OnAttackEventHandlerScript = ApplyEffect_OnAttackEventHandlerScript;
